import React, { useState, useEffect, useCallback } from 'react';

const heroSlides = [
  {
    id: 1,
    title: 'Expert Barber Services',
    subtitle: 'Professional cuts and grooming by skilled barbers',
    cta: 'Book Now',
    ctaLink: '/shops',
    backgroundImage: 'https://ogestyleimages.blob.core.windows.net/ogestyle-images/images/1.jpg',
  },
  {
    id: 2,
    title: 'Wellness & Yoga',
    subtitle: 'Find peace and balance with expert yoga instructors',
    cta: 'Explore Classes',
    ctaLink: '/shops',
    backgroundImage: 'https://ogestyleimages.blob.core.windows.net/ogestyle-images/images/3.jpg',
  },
  {
    id: 3,
    title: 'Luxury Spa Experience',
    subtitle: 'Relax and rejuvenate with premium spa treatments',
    cta: 'Book Spa',
    ctaLink: '/shops',
    backgroundImage: 'https://ogestyleimages.blob.core.windows.net/ogestyle-images/images/4.jpg',
  },
  {
    id: 4,
    title: 'Hair Salon Services',
    subtitle: 'Transform your look with top-rated hair stylists',
    cta: 'Find Stylists',
    ctaLink: '/shops',
    backgroundImage: 'https://ogestyleimages.blob.core.windows.net/ogestyle-images/images/6.jpg',
  },
];

function HeroSlideshow() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 'clamp(400px, 50vw, 500px)',
        minHeight: '400px',
        overflow: 'hidden',
        background: '#14314f',
      }}
    >
      {heroSlides.map((slide, index) => {
        const isActive = index === currentSlide;
        return (
          <div
            key={slide.id}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `linear-gradient(180deg, rgba(12,25,40,0.32) 0%, rgba(12,25,40,0.52) 100%), url(${slide.backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: isActive ? 1 : 0,
              transition: 'opacity 1s ease',
              zIndex: isActive ? 1 : 0,
            }}
          >
            <div
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '36px 24px 150px',
                boxSizing: 'border-box',
              }}
            >
              <h1
                className="hero-slideshow-title"
                style={{
                  margin: '0 0 12px',
                  fontFamily: 'Fraunces, Georgia, serif',
                  fontSize: 'clamp(22px, 3vw, 36px)',
                  fontWeight: 700,
                  lineHeight: 1.15,
                  letterSpacing: '-0.02em',
                  color: '#fff',
                  textShadow: '0 2px 16px rgba(10,22,36,0.35)',
                  maxWidth: '880px',
                }}
              >
                {slide.title}
              </h1>
              <p
                className="hero-slideshow-subtitle"
                style={{
                  margin: '0 0 26px',
                  fontSize: 'clamp(15px, 1.8vw, 20px)',
                  lineHeight: 1.5,
                  color: 'rgba(255,255,255,0.94)',
                  textShadow: '0 1px 12px rgba(10,22,36,0.35)',
                  maxWidth: '620px',
                }}
              >
                {slide.subtitle}
              </p>
              <a
                href={slide.ctaLink}
                className="hero-slideshow-cta"
                style={{
                  display: 'inline-block',
                  background: '#fff',
                  color: '#14314f',
                  padding: '14px 34px',
                  borderRadius: '999px',
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '17px',
                  boxShadow: '0 8px 22px rgba(10,22,36,0.25)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 12px 26px rgba(10,22,36,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 22px rgba(10,22,36,0.25)';
                }}
              >
                {slide.cta}
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default HeroSlideshow;
